import { Mail } from "lucide-react";
import { WorkflowV2NodeDto } from "@babackapp/private-api-client/types";
import { NodeCategory, registerNode } from "../../lib/register-node";
import { ReturnEmailActionNodeEditor } from "./editor";
import { ReturnEmailActionNodePanel } from "./panel";
import { ReturnEmailActionNodeProps } from "./types";
import { ReturnEmailActionNodeDataDto } from "../node-types";

const newNodeDefaultValue: ReturnEmailActionNodeDataDto = {
  actionType: "send_return_email",
  // recipient is informational in v1 (the engine always sends to the
  // customer); templateId must be picked by the merchant.
  config: { templateId: null, recipient: "customer" },
};

export default registerNode<ReturnEmailActionNodeProps["data"]>({
  type: "action:send_return_email",
  name: "workflowsEditor.nodes.sendReturnEmail.title",
  description: "workflowsEditor.nodes.sendReturnEmail.description",
  Icon: Mail,
  category: NodeCategory.ACTION,
  color: "green",
  editor: {
    component: ReturnEmailActionNodeEditor,
  },
  configPanel: {
    component: ReturnEmailActionNodePanel,
  },
  // Extended action type outside the generated V2 union (return engine).
  newNodeDefaultData: newNodeDefaultValue as unknown as WorkflowV2NodeDto["data"],
});

export * from "./types";
export { ReturnEmailActionNodeEditor } from "./editor";
export { ReturnEmailActionNodePanel } from "./panel";
